import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Avatar,
  Box,
  Grid,
  Divider,
  Chip,
  useTheme
} from "@mui/material";
import {
  Person,
  Badge,
  Engineering,
  Email,
  Business,
  PowerSettingsNew,
  Phone,
  WcRounded
} from "@mui/icons-material";
import defaultImage from "../../assets/user.png";
const ProfilPersonnelModal = ({ open, onClose, user }) => {
  const theme = useTheme();

  if (!user) return null;

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: 3,
          [theme.breakpoints.down('sm')]: {
            margin: 1
          }
        }
      }}
    >
      <DialogTitle 
        sx={{ 
          bgcolor: theme.palette.primary.main,
          color: 'white',
          py: 3,
          textAlign: 'center'
        }}
      >
        <Avatar
          src={user.image || defaultImage}
          alt={user.full_name}
          sx={{ 
            width: 100,
            height: 100,
            margin: '0 auto',
            mb: 2,
            border: '4px solid white',
            boxShadow: theme.shadows[3]
          }}
        />
        <Typography variant="h5" component="div">
          {user.full_name}
        </Typography>
        <Chip
          label={user.statut ? "Actif" : "Inactif"}
          color={user.statut ? "success" : "error"}
          sx={{ 
            mt: 2,
            color: 'white',
            fontWeight: 'bold',
            borderRadius: 1
          }}
        />
      </DialogTitle>

      <DialogContent sx={{ p: 4 }}>
        <Grid container spacing={3}>
          {/* Colonne gauche - Informations générales */}
          <Grid item xs={12} md={4}>
            <Box sx={{ textAlign: 'left', mt: 2 }}>
              <Typography variant="subtitle2" color="textSecondary">
                <Badge sx={{ mr: 1, verticalAlign: 'middle' }} />
                MATRICULE
              </Typography>
              <Typography variant="body1" paragraph>
                {user.matricule || 'N/A'}
              </Typography>

              <Typography variant="subtitle2" color="textSecondary" mt={2}>
                <Engineering sx={{ mr: 1, verticalAlign: 'middle' }} />
                RÔLE
              </Typography>
              <Typography variant="body1" paragraph>
                {user.role ? user.role.split('_').map(word => 
                  word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : 'N/A'}
              </Typography>

              <Typography variant="subtitle2" color="textSecondary" mt={2}>
                <WcRounded sx={{ mr: 1, verticalAlign: 'middle' }} />
                GENRE
              </Typography>
              <Typography variant="body1" paragraph>
                {user.genre ? user.genre.charAt(0).toUpperCase() + user.genre.slice(1) : 'N/A'}
              </Typography>
            </Box>
          </Grid>

          {/* Colonne droite - Détails */}
          <Grid item xs={12} md={8}>
            <Divider sx={{ mb: 3 }}>Informations de contact</Divider>

            <DetailItem 
              icon={<Email />} 
              title="Email" 
              value={user.email}
            />

            <DetailItem 
              icon={<Phone />} 
              title="Téléphone" 
              value={user.tel || 'N/A'}
            />

            <DetailItem
              icon={<Business />}
              title="Partenaire"
              value={user.partenaire?.intitule || 'N/A'}
            />

            <Divider sx={{ my: 3 }}>Statistiques</Divider>

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <StatBox title="Dossiers traités" value="245" />
              </Grid>
              <Grid item xs={6}>
                <StatBox title="Années d'expérience" value="3" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: 3, borderTop: `1px solid ${theme.palette.divider}` }}>
        <Button 
          onClick={onClose} 
          variant="outlined" 
          startIcon={<PowerSettingsNew />}
          sx={{ borderRadius: 2 }}
        >
          Fermer le profil
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// Composant réutilisable pour les éléments de détail
const DetailItem = ({ icon, title, value }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
    <Box sx={{ 
      bgcolor: 'action.hover', 
      p: 1.5, 
      borderRadius: 1,
      mr: 2,
      display: 'flex',
      alignItems: 'center'
    }}>
      {React.cloneElement(icon, { color: 'primary' })}
    </Box>
    <div>
      <Typography variant="subtitle2" color="textSecondary">
        {title}
      </Typography>
      <Typography variant="body1">
        {value}
      </Typography>
    </div>
  </Box>
);

// Composant réutilisable pour les statistiques
const StatBox = ({ title, value }) => (
  <Box sx={{ 
    bgcolor: 'background.paper',
    p: 2,
    borderRadius: 2,
    textAlign: 'center',
    boxShadow: 1
  }}>
    <Typography variant="h4" color="primary">
      {value}
    </Typography>
    <Typography variant="subtitle2" color="textSecondary">
      {title}
    </Typography>
  </Box>
);

export default ProfilPersonnelModal;